<template>
  <span class="labelRate_List">
    <tk-icon
      v-for="n in onCnt"
      :key="`tkrate_on-navItem__${n}`"
      :name="onIcon"
    />
    <tk-icon v-if="onHalfCnt > 0" :name="halfIcon" />
    <tk-icon
      v-for="n in offCnt"
      :key="`tkrate_off-navItem__${n}`"
      :name="offIcon"
    />
  </span>
</template>

<script>
import TkIcon from '../../atoms/TkIcon/TkIcon'
export default {
  name: 'TkRate',
  components: { TkIcon },
  props: {
    rate: {
      type: Number,
      required: true,
    },
    maxRate: {
      type: Number,
      required: false,
      default: 5,
    },
    onIcon: {
      type: String,
      default: 'star_on',
      required: false,
    },
    offIcon: {
      type: String,
      default: 'star_off',
      required: false,
    },
    halfIcon: {
      type: String,
      default: 'halfstar_on',
      required: false,
    },
  },
  computed: {
    onCnt() {
      return Math.floor(this.rate)
    },
    onHalfCnt() {
      return this.rate - Math.floor(this.rate)
    },
    offCnt() {
      var offCnt = 0
      if (this.rate <= this.maxRate) {
        offCnt = Math.floor(this.maxRate - this.rate)
      }
      return offCnt
    },
  },
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/components/TkRate.scss';
</style>
